import React from 'react';
export const Footer: React.FC = () => {
  return <footer className="bg-[#000000] py-8 mt-auto print:hidden" data-id="element-376">
      <div className="container mx-auto px-4 md:px-6 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-377">
        <p className="text-[#FFFFFF] text-sm font-medium" data-id="element-378">
          Powered by Brandpulse
        </p>
      </div>
    </footer>;
};